import { render, staticRenderFns } from "./SetPasswordModal.vue?vue&type=template&id=78f06a78&"
import script from "./SetPasswordModal.vue?vue&type=script&lang=js&"
export * from "./SetPasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.2_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0__lodash_7gprpqnc7s6aitlohrfuswmoxa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports